import { ExternalLink } from "lucide-react";
import SEO, { reviewsSchema, breadcrumbSchema } from "../components/SEO";
import { SectionLabel, Stars, Breadcrumbs, CTASection } from "../components/Shared";
import { TESTIMONIALS, IMAGES, BRAND } from "../data/siteData";

const crumbs = [{ name: "Home", path: "/" }, { name: "Reviews", path: "/reviews" }];

export default function ReviewsPage() {
  return (
    <>
      <SEO
        title="Vantyx Coatings Reviews | 5-Star Garage Floors Phoenix Metro"
        description="Read 5-star reviews from Vantyx Coatings customers across Scottsdale, Gilbert, Chandler, Peoria and the Phoenix Metro. TRI-BOND™ garage floors backed for life."
        path="/reviews"
        ogImage={IMAGES.garage3}
        schemas={[reviewsSchema(TESTIMONIALS), breadcrumbSchema(crumbs)]}
      />

      <section className="hero-gradient py-20 md:py-24 px-6 md:px-12 grain relative" data-testid="reviews-hero">
        <div className="max-w-7xl mx-auto">
          <Breadcrumbs items={crumbs} />
          <SectionLabel>Customer Reviews</SectionLabel>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white">
            Rated <span className="text-[#E8B86D]">5.0</span> by Phoenix Metro Homeowners
          </h1>
          <div className="flex items-center gap-3 mt-6">
            <Stars size={22} />
            <span className="text-gray-300">Based on verified customer reviews</span>
          </div>
        </div>
      </section>

      <section className="bg-white py-24 md:py-32 px-6 md:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="reviews-grid">
            {TESTIMONIALS.map((t) => (
              <div key={t.name} className="border border-gray-200 p-8 flex flex-col shadow-sm">
                <Stars count={t.stars} />
                <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1">"{t.text}"</p>
                <p className="text-[#000000] font-semibold text-sm mt-5">{t.name} <span className="text-gray-400 font-normal">· {t.city}, AZ</span></p>
              </div>
            ))}
          </div>
          <div className="mt-14 bg-gray-50 border border-gray-200 p-8 md:p-10 text-center">
            <h2 className="font-display text-2xl font-bold text-[#000000] mb-3">See us on Google</h2>
            <p className="text-gray-500 text-sm mb-6 max-w-xl mx-auto">Every review above is from a real Vantyx customer. Find more on our Google Business Profile — or leave one of your own after your install.</p>
            <a
              href={BRAND.social.google}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="google-reviews-link"
              className="inline-flex items-center gap-2 bg-[#028090] text-white hover:bg-[#026c7a] transition-colors duration-300 px-8 py-4 uppercase font-bold tracking-wider text-sm"
            >
              View Google Business Profile <ExternalLink size={16} />
            </a>
          </div>
        </div>
      </section>

      <CTASection title="Join the 5-Star Club" subtitle="Free in-home estimate, one-day install, lifetime warranty — and a floor worth bragging about." />
    </>
  );
}
